import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { ProductService } from 'src/app/_service/product.service';

declare var $: any;


@Component({
  selector: 'app-product-track-model',
  templateUrl: './product-track-model.component.html',
  styleUrls: ['./product-track-model.component.css']
})
export class ProductTrackModelComponent implements OnInit {

  dialogData: any; loading: boolean = false; productOrderForm: FormGroup; dataLoaded: boolean = false; submitted: boolean = false;
  createProductOrder:boolean=true; FieldHideOnResponseData: boolean = false;
  constructor(public dialogRef: MatDialogRef<ProductTrackModelComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, private formBuilder: FormBuilder, private sharedapi: SharedService, private leadapi: LeadsService, private productapi: ProductService) {
    this.dialogData = data;
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.productOrderForm = this.formBuilder.group({
      'product_booking_id': [null],
      'order_id': [null, Validators.required],
      'shipping_customer_name': [null, Validators.required],
      'shipping_address': [null, Validators.required],
      'shipping_city': [null, Validators.required],
      'shipping_pincode': [null, Validators.required],
      'shipping_country': [null, Validators.required],
      'shipping_state': [null, Validators.required],
      'shipping_email': [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
      'shipping_phone': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'name': [null, Validators.required],
      'units': [null, Validators.required],
      'selling_price': [null, Validators.required],
      'payment_method': [null, Validators.required],
      'sub_total': [null, Validators.required],
      'length': [null, Validators.required],
      'breadth': [null, Validators.required],
      'height': [null, Validators.required],
      'weight': [null, Validators.required],
      'product_order_date': [null],
    });
  }

  ngOnInit(): void {
    if(this.dialogData.lead_id)
    {
      this.createProductOrder=true;
      this.getProductLeadDetail();
      this.getProductDetail();
    } 
    else if(this.dialogData.res_order_id)
    {
      this.createProductOrder=false;
      this.patchOrderdProductData();
    }
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  get f() { return this.productOrderForm.controls; }

  async getProductLeadDetail() {
    this.dataLoaded = false;
    await this.leadapi.getProductLeadDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        this.productOrderForm.controls['shipping_customer_name'].setValue(data.data.lead_name);
        this.productOrderForm.controls['shipping_phone'].setValue(data.data.mobile);
      } else {
        this.sharedapi.checkError(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getProductDetail() {
    this.dataLoaded = false;
    await this.leadapi.getProductDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        this.productOrderForm.controls['shipping_address'].setValue(data.data.address);
        this.productOrderForm.controls['product_booking_id'].setValue(data.data.product_booking_id);
      } else {
        this.sharedapi.checkError(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async productOrderSubmit() {
    this.submitted = true;
    this.loading = true;
    if (this.productOrderForm.invalid) {
      this.loading = false;
      return;
    }
    //  for product order update
    if(!this.createProductOrder)
    {
      await this.productapi.updateProductOrderDetail(this.productOrderForm.value).subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
          this.patchOrderdProductData();
        } else {
          this.sharedapi.presentToast(data.msg.message);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    } else {
      // for product order add 
      await this.productapi.productOrderSubmitDetail(this.productOrderForm.value).subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
        } else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });

    }
   
  }


  async checkPinCode() {
    let pinCode = this.productOrderForm.controls['shipping_pincode'].value;
    await this.productapi.getAddressUsingPincode(pinCode).subscribe((data: any) => {
      if (data.status) {
        if (data.data.postcode_details) {
          this.productOrderForm.controls['shipping_city'].setValue(data.data.postcode_details.city);
          this.productOrderForm.controls['shipping_state'].setValue(data.data.postcode_details.state);
          this.productOrderForm.controls['shipping_country'].setValue(data.data.postcode_details.country);
        }
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async patchOrderdProductData(){
    let product_data = {
        "res_order_id": parseInt(this.dialogData.res_order_id),
    }
    await this.productapi.getOrderdProductData(product_data).subscribe((response:any) => {
      this.dataLoaded = true;
       if(response.status){
        var p_created_date = response.data.data.created_at;
        var p_date = new Date(p_created_date);
        var p_month = p_date.getMonth()+1;
        var product_order_date = p_date.getFullYear()+"-"+p_month+"-"+p_date.getDate();
    
           this.productOrderForm.patchValue({
              'order_id':response.data.data.channel_order_id,  
              'shipping_customer_name':response.data.data.billing_name,  
              'shipping_address':response.data.data.billing_address,
              'shipping_city':response.data.data.billing_city,
              'shipping_pincode':response.data.data.billing_pincode,  
              'shipping_country':response.data.data.billing_country_name,  
              'shipping_state':response.data.data.billing_state_name,
              'shipping_email':response.data.data.billing_email,
              'shipping_phone':response.data.data.billing_phone,
              'name':response.data.data.products[0].name,
              'units':response.data.data.products[0].quantity,
              'selling_price':response.data.data.products[0].selling_price,
              'payment_method':response.data.data.payment_method,
              'sub_total':response.data.data.total,
              'length':response.data.data.shipments.length,
              'breadth':response.data.data.shipments.breadth,
              'height':response.data.data.shipments.height,
              'weight':response.data.data.shipments.weight,
              'product_order_date':product_order_date
           })
       }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

}
